import React from 'react';
import ActivityFeedWidget from './ActivityFeedWidget';

const ActivityFeedWidgetBasic = () => (
  <ActivityFeedWidget className="masonry-item w-[440px] h-[680px] flex flex-col" />
);

export default ActivityFeedWidgetBasic;
